import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { RocFormData } from '../../types/RocFormData'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { RocFormField } from '../../types/RocFormField'

export class NarrativeSectionAdapter extends SectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const background = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_BACKGROUND]],
      RocAssessmentQuestionnaireItem.NARRATIVE_BACKGROUND
    )?.at(0)
    const systemSummaries = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_SYSTEM_SUMMARIES]],
      RocAssessmentQuestionnaireItem.NARRATIVE_SYSTEM_SUMMARIES
    )?.at(0)
    const clinicalOverview = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_OVERVIEW]],
      RocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_OVERVIEW
    )?.at(0)
    const skilledNeeds = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_SKILLED_NEEDS]],
      RocAssessmentQuestionnaireItem.NARRATIVE_SKILLED_NEEDS
    )?.at(0)
    const adlNeeds = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_ADL_NEEDS]],
      RocAssessmentQuestionnaireItem.NARRATIVE_ADL_NEEDS
    )?.at(0)
    const patientServices = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_SERVICES]],
      RocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_SERVICES
    )?.at(0)
    const careCoordination = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_CARE_COORDINATION]],
      RocAssessmentQuestionnaireItem.NARRATIVE_CARE_COORDINATION
    )?.at(0)
    const patientGoals = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_GOALS]],
      RocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_GOALS
    )?.at(0)
    const clinicalEducation = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_EDUCATION]],
      RocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_EDUCATION
    )?.at(0)
    const finalNotes = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.NARRATIVE_FINAL_NOTES]],
      RocAssessmentQuestionnaireItem.NARRATIVE_FINAL_NOTES
    )?.at(0)

    return {
      [RocFormField.NARRATIVE_BACKGROUND]: background,
      [RocFormField.NARRATIVE_SYSTEM_SUMMARIES]: systemSummaries,
      [RocFormField.NARRATIVE_CLINICAL_OVERVIEW]: clinicalOverview,
      [RocFormField.NARRATIVE_SKILLED_NEEDS]: skilledNeeds,
      [RocFormField.NARRATIVE_ADL_NEEDS]: adlNeeds,
      [RocFormField.NARRATIVE_PATIENT_SERVICES]: patientServices,
      [RocFormField.NARRATIVE_CARE_COORDINATION]: careCoordination,
      [RocFormField.NARRATIVE_PATIENT_GOALS]: patientGoals,
      [RocFormField.NARRATIVE_CLINICAL_EDUCATION]: clinicalEducation,
      [RocFormField.NARRATIVE_FINAL_NOTES]: finalNotes
    }
  }
  buildFlatAnswers(formData: RocFormData): FlatAnswerMutation[] {
    return [
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_BACKGROUND,
        value: formData[RocFormField.NARRATIVE_BACKGROUND]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_SYSTEM_SUMMARIES,
        value: formData[RocFormField.NARRATIVE_SYSTEM_SUMMARIES]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_OVERVIEW,
        value: formData[RocFormField.NARRATIVE_CLINICAL_OVERVIEW]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_SKILLED_NEEDS,
        value: formData[RocFormField.NARRATIVE_SKILLED_NEEDS]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_ADL_NEEDS,
        value: formData[RocFormField.NARRATIVE_ADL_NEEDS]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_SERVICES,
        value: formData[RocFormField.NARRATIVE_PATIENT_SERVICES]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_CARE_COORDINATION,
        value: formData[RocFormField.NARRATIVE_CARE_COORDINATION]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_PATIENT_GOALS,
        value: formData[RocFormField.NARRATIVE_PATIENT_GOALS]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_CLINICAL_EDUCATION,
        value: formData[RocFormField.NARRATIVE_CLINICAL_EDUCATION]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.NARRATIVE_FINAL_NOTES,
        value: formData[RocFormField.NARRATIVE_FINAL_NOTES]
      }
    ]
  }
}
